module.exports = __webpack_public_path__ + "static/media/discover-yourself-video.1702d2b8.mp4";